export const SUBSCRIPTION_API_ROUTES = {
    SUBSCRIPTION_PLAN_ALL: 'subscription/subscriptionPlanAll',
    SUBSCRIBE_STUDENT_PLAN: 'subscription/subscribeStudentPlan'
}